export default class TrackableEvent {
  constructor({
    eventType = '',
    eventProps = {}
  }) {
    this.eventType = eventType;
    this.eventProps = eventProps;
  }

}